import { PlatformCatalogAccessMatchingRuleCriteria } from "@bvhi/backend-api/apis";
import { useTranslation } from "react-i18next";

export const useMatchingRules = () => {
  const { t } = useTranslation(["enums"]);

  const getMatchingCriteriaStringRepresentation = (criteria: PlatformCatalogAccessMatchingRuleCriteria): string => {
    switch (criteria) {
      case PlatformCatalogAccessMatchingRuleCriteria.EQUALS:
        return t("enums:enums.platform.catalog.access.matching.rule.critera.equals");
      case PlatformCatalogAccessMatchingRuleCriteria.HIGHER:
        return t("enums:enums.platform.catalog.access.matching.rule.critera.higher");
      case PlatformCatalogAccessMatchingRuleCriteria.HIGHER_OR_EQUALS:
        return t("enums:enums.platform.catalog.access.matching.rule.critera.higher.or.equals");
      case PlatformCatalogAccessMatchingRuleCriteria.LOWER:
        return t("enums:enums.platform.catalog.access.matching.rule.critera.lower");
      case PlatformCatalogAccessMatchingRuleCriteria.LOWER_OR_EQUALS:
        return t("enums:enums.platform.catalog.access.matching.rule.critera.lower.or.equals");
      case PlatformCatalogAccessMatchingRuleCriteria.NOT_EQUALS:
        return t("enums:enums.platform.catalog.access.matching.rule.critera.not.equals");
    }
  };

  return { getMatchingCriteriaStringRepresentation };
};
